<template>
    <rkm-tabs
        :tab-refs="tabRefs"
        v-model="tabIndex"
    >
        <rkm-tab
            active
            title="Identificação"
        >
            <TabIdentificacao
                :data="data"
                ref="TabIdentificacao"
            />
        </rkm-tab>

        <rkm-tab title="Endereço">
            <TabEndereco
                :data="data"
                ref="TabEndereco"
            />
        </rkm-tab>

        <rkm-tab title="Contatos">
            <TabContatos
                :data="data"
                ref="TabContatos"
            />
        </rkm-tab>
    </rkm-tabs>
</template>

<script>
// Components.
import TabIdentificacao from './components/identificacao/Form'
import TabEndereco from './components/endereco/Form'
import TabContatos from './components/contato/Index'

export default {
    components: { TabIdentificacao, TabEndereco, TabContatos },
    props: {
        data: { type: Object, required: true }
    },
    data: () => ({
        tabIndex: 0,
        tabRefs: [],
    }),
    methods: {
        async validate() {

            const currentValid = await this.tabRefs[this.tabIndex].validate()

            if (!currentValid) {

                return false;
            }

            let valid = true

            for (let i = 0; i < this.tabRefs.length; i++) {

                if (i !== this.tabIndex) {

                    valid = await this.tabRefs[i].validate()

                    if (!valid) {

                        this.tabIndex = i

                        break
                    }
                }
            }

            return valid
        },
    },
    mounted() {

        this.tabRefs = [
            this.$refs.TabIdentificacao,
            this.$refs.TabEndereco,
            this.$refs.TabContatos,
        ]
    }
}
</script>